export const STORE_COMMISSION_GRID_COMPONENT = 'gridStoreCommissionPercent';
export const PAYOUT_STATEMENT_GRID_COMPONENT = 'gridPayoutStatement';

const AUTO_HEIGHT_GRID_COMPONENTS = new Set([
    STORE_COMMISSION_GRID_COMPONENT
]);

function getDashboardItemName(args) {
    const item = args.getDashboardItem?.() ?? args.dashboardItem;
    return item?.componentName?.() ?? item?.name?.() ?? item?.name;
}

/**
 * Payout dashboard grids: summary grids size to content; main grid fills its slot and scrolls.
 * Native column totals footer stays pinned in the same grid as the product lines.
 */
export function onCommissionPercentGridWidgetOptionsPrepared(args) {
    const componentName = getDashboardItemName(args);
    const options = args.options;
    if (!options) {
        return;
    }

    if (AUTO_HEIGHT_GRID_COMPONENTS.has(componentName)) {
        options.height = 'auto';
        return;
    }

    if (componentName === PAYOUT_STATEMENT_GRID_COMPONENT) {
        options.height = '100%';
        options.scrolling = {
            mode: 'standard',
            showScrollbar: 'always',
            useNative: true
        };
    }
}
